<template>
  <div></div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "CertificateDownload",
  data() {
    return {
      images: {},
      imageCount: 2,
      currentImageCount: 0,
    };
  },
  props: {
    locale: {
      type: String,
      default: "de",
    },
  },
  watch: {
    currentImageCount: function (nVal) {
      if (nVal == this.imageCount) {
        this.pdfgen();
        this.$store.commit("loadingFlow");
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: "user/profile/current",
      user: "user/current",
    }),
    imagesLoaded() {
      return this.currentImageCount == this.imageCount;
    },
    certDate() {
      return moment(new Date())
        .locale(this.locale)
        .format(this.$t("locale.textDateFormat", this.locale));
    },
    birthdate() {
      return moment(new Date(new Date(this.profile.birthdate * 1000))).format(
        this.$t("locale.dateFormat", this.locale)
      );
    },
    registerDate() {
      return moment(new Date(this.user.modified.created * 1000))
        .locale(this.locale)
        .format(this.$t("locale.textMonthDateFormat", this.locale));
    },
  },
  methods: {
    download() {
      if (!this.imagesLoaded) {
        this.$store.commit("loadingFlow");
        var that = this;
        this.toSvgURL("/assets/certificate/logo_default.svg", function (data) {
          that.images.logo = data;
          that.currentImageCount++;
        });
        this.toDataURL(
          process.env.VUE_APP_BACKEND_URL + "/assets/signature_cs.png",
          function (data) {
            that.images.signature = data;
            that.currentImageCount++;
          }
        );
      } else {
        this.pdfgen();
      }
    },
    toDataURL: function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open("get", url);
      xhr.setRequestHeader("Content-Type", "image/png");
      xhr.withCredentials = true;
      xhr.responseType = "blob";
      xhr.onload = function () {
        var fr = new FileReader();
        fr.onload = function () {
          callback(this.result);
        };
        fr.readAsDataURL(xhr.response); // async call
      };
      xhr.send();
    },
    toSvgURL: function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open("get", url);
      xhr.setRequestHeader("Content-Type", "image/svg+xml");
      xhr.withCredentials = true;
      xhr.responseType = "blob";
      xhr.onload = function () {
        var fr = new FileReader();
        fr.onload = function () {
          callback(this.result);
        };
        fr.readAsText(xhr.response); // async call
      };
      xhr.send();
    },
    pdfgen: function () {
      var pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        //userPassword: '123',
        ownerPassword: "123456",
        permissions: {
          printing: "lowResolution",
          modifying: false,
          copying: false,
          annotating: true,
          fillingForms: true,
          contentAccessibility: false,
          documentAssembly: true,
        },
        // inhalt des PDFs
        content: [
          {
            // Logo image
            svg: this.images.logo,
            width: 120,
            height: 69,
            absolutePosition: { x: 70, y: 40 },
          },
          // Organisation stuff
          {
            text: this.t_org("header.address"),
            style: "header_org_address",
            absolutePosition: { x: 370, y: 60 },
          },
          {
            text: this.t_org("header.mail"),
            style: "header_org_address",
            absolutePosition: { x: 370, y: 86 },
          },
          {
            text: this.t_org("header.website"),
            style: "header_org_address_underline",
            absolutePosition: { x: 370, y: 98 },
          },
          {
            text: this.t_cert("certificate_date", {
              0: this.certDate,
            }),
            style: "certificate_date",
            absolutePosition: { x: 360, y: 235 },
          },
          {
            text: this.t_org("inline"),
            style: "inline_organisation",
            absolutePosition: { x: 70, y: 165 },
          },
          {
            text:
              this.user.full_name +
              "\n" +
              this.user.address.street +
              " " +
              this.user.address.number +
              "\n" +
              this.user.address.zip +
              " " +
              this.user.address.city,
            style: "supporter",
            absolutePosition: { x: 70, y: 185 },
          },
          {
            text: this.t_cert("headline", {
              0: this.user.full_name,
            }),
            style: "headline",
            absolutePosition: { x: 70, y: 270 },
          },
          {
            text: this.t_cert("body.1", {
              0: this.user.full_name,
              1: this.birthdate,
              2: this.registerDate,
            }),
            style: "first_paragraph",
          },
          {
            text: this.t_cert("body.2", {
              0: this.user.full_name,
              1: this.user.crew.name,
            }),
            style: "paragraph",
          },
          {
            text: this.t_cert("body.3", {
              0: this.user.full_name,
            }),
            style: "paragraph",
          },
          {
            text: this.t_cert("body.greetings"),
            style: "paragraph",
          },
          {
            // Image signature
            image: this.images.signature,
            width: 150,
            height: 35,
            marginLeft: 30,
          },
          {
            text: this.t_cert("body.signature"),
            style: "signature",
          },
        ],
        footer: {
          columns: [
            {
              text: this.t_org("footer.account"),
              style: "footer_highlight",
              absolutePosition: { x: 70, y: 0 },
            },
            {
              text:
                this.t_org("footer.iban_prefix") + this.t_org("footer.iban"),
              style: "footer_value",
              absolutePosition: { x: 70, y: 10 },
            },
            {
              text: this.t_org("footer.bic"),
              style: "footer_value",
              absolutePosition: { x: 70, y: 20 },
            },
            {
              text: this.t_org("footer.legal"),
              style: "footer_value",
              absolutePosition: { x: 225, y: 10 },
            },
            {
              text: this.t_org("footer.register"),
              style: "footer_value",
              absolutePosition: { x: 225, y: 20 },
            },
            {
              text: this.t_org("footer.tax_number"),
              style: "footer_value",
              absolutePosition: { x: 424, y: 10 },
            },
            {
              text: this.t_org("footer.tax_office"),
              style: "footer_value",
              absolutePosition: { x: 424, y: 20 },
            },
          ],
        },
        styles: {
          // Header stuff
          header_org_address: {
            fontSize: 9,
            lineHeight: 1.2,
            alignment: "left",
          },
          header_org_address_underline: {
            fontSize: 9,
            lineHeight: 1.2,
            alignment: "left",
            decoration: "underline",
          },
          inline_organisation: {
            fontSize: 8,
            bold: true,
            alignment: "left",
            color: "#11499E",
          },
          certificate_date: {
            fontSize: 11,
            alignment: "right",
          },
          headline: {
            fontSize: 13,
            alignment: "left",
            color: "#11499E",
          },
          first_paragraph: {
            fontSize: 11,
            lineHeight: 1.2,
            alignment: "justify",
            margin: [30, 235, 0, 0],
          },
          paragraph: {
            fontSize: 11,
            lineHeight: 1.2,
            alignment: "justify",
            margin: [30, 5, 0, 10],
          },
          signature: {
            fontSize: 11,
            lineHeight: 1.2,
            margin: [30, 8, 0, 10],
          },
          footer_highlight: {
            fontSize: 8,
            bold: true,
            alignment: "left",
            color: "#11499E",
          },
          footer_value: {
            fontSize: 8,
            alignment: "left",
          },
        },
        pageSize: "A4",
        pageMargins: [40, 60, 60, 60],
      };
      pdfMake.createPdf(docDefinition).download(this.t_cert("filename"));
    },
    t_cert(key, ...args) {
      return this.$t("profile.certificate." + key, this.locale, ...args);
    },
    t_org(key) {
      return this.t_cert("organisation." + key);
    },
  },
};
</script>
